import Enum from "./Enum";

export default Enum.create( {
	INVITED: "INVITED",
	ACTIVE: "ACTIVE",
	DEFERRED: "DEFERRED",
} );
